"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.View = exports.TrackVertical = exports.TrackHorizontal = exports.ThumbVertical = exports.ThumbHorizontal = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _constants = require("../../assets/js/constants");

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var View = _styledComponents["default"].div.withConfig({
  displayName: "styled__View",
  componentId: "sc-19wfx1x-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    ", ";\n    padding-right: 6px;\n    padding-bottom: 6px;\n    ", ";\n"])), function (p) {
  var _p$extStyle;

  return (_p$extStyle = p.extStyle) !== null && _p$extStyle !== void 0 ? _p$extStyle : '';
}, function (p) {
  var _p$customStyles$view, _p$customStyles;

  return (_p$customStyles$view = (_p$customStyles = p.customStyles) === null || _p$customStyles === void 0 ? void 0 : _p$customStyles.view) !== null && _p$customStyles$view !== void 0 ? _p$customStyles$view : '';
});

exports.View = View;

var TrackVertical = _styledComponents["default"].div.withConfig({
  displayName: "styled__TrackVertical",
  componentId: "sc-19wfx1x-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    ", ";\n    right: 0;\n    bottom: 2px;\n    top: 0;\n    width: 4px;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, .05);\n    ", ";\n"])), function (p) {
  var _p$extStyle2;

  return (_p$extStyle2 = p.extStyle) !== null && _p$extStyle2 !== void 0 ? _p$extStyle2 : '';
}, function (p) {
  var _p$customStyles$track, _p$customStyles2;

  return (_p$customStyles$track = (_p$customStyles2 = p.customStyles) === null || _p$customStyles2 === void 0 ? void 0 : _p$customStyles2.trackVertical) !== null && _p$customStyles$track !== void 0 ? _p$customStyles$track : '';
});

exports.TrackVertical = TrackVertical;

var ThumbVertical = _styledComponents["default"].div.withConfig({
  displayName: "styled__ThumbVertical",
  componentId: "sc-19wfx1x-2"
})(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    ", ";\n    width: 4px;\n    height: 40px;\n    border-radius: 2px;\n    background-color: ", ";\n    ", ";\n"])), function (p) {
  var _p$extStyle3;

  return (_p$extStyle3 = p.extStyle) !== null && _p$extStyle3 !== void 0 ? _p$extStyle3 : '';
}, _constants.COLORS.grey, function (p) {
  var _p$customStyles$thumb, _p$customStyles3;

  return (_p$customStyles$thumb = (_p$customStyles3 = p.customStyles) === null || _p$customStyles3 === void 0 ? void 0 : _p$customStyles3.thumbVertical) !== null && _p$customStyles$thumb !== void 0 ? _p$customStyles$thumb : '';
});

exports.ThumbVertical = ThumbVertical;

var TrackHorizontal = _styledComponents["default"].div.withConfig({
  displayName: "styled__TrackHorizontal",
  componentId: "sc-19wfx1x-3"
})(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n    ", ";\n    right: 2px;\n    bottom: 0;\n    left: 0;\n    height: 4px;\n    border-radius: 2px;\n    background-color: rgba(0, 0, 0, .05);\n    ", ";\n"])), function (p) {
  var _p$extStyle4;

  return (_p$extStyle4 = p.extStyle) !== null && _p$extStyle4 !== void 0 ? _p$extStyle4 : '';
}, function (p) {
  var _p$customStyles$track2, _p$customStyles4;

  return (_p$customStyles$track2 = (_p$customStyles4 = p.customStyles) === null || _p$customStyles4 === void 0 ? void 0 : _p$customStyles4.trackHorizontal) !== null && _p$customStyles$track2 !== void 0 ? _p$customStyles$track2 : '';
});

exports.TrackHorizontal = TrackHorizontal;

var ThumbHorizontal = _styledComponents["default"].div.withConfig({
  displayName: "styled__ThumbHorizontal",
  componentId: "sc-19wfx1x-4"
})(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n    ", ";\n    width: 40px;\n    height: 4px;\n    border-radius: 2px;\n    background-color: ", ";\n    ", ";\n"])), function (p) {
  var _p$extStyle5;

  return (_p$extStyle5 = p.extStyle) !== null && _p$extStyle5 !== void 0 ? _p$extStyle5 : '';
}, _constants.COLORS.grey, function (p) {
  var _p$customStyles$thumb2, _p$customStyles5;

  return (_p$customStyles$thumb2 = (_p$customStyles5 = p.customStyles) === null || _p$customStyles5 === void 0 ? void 0 : _p$customStyles5.thumbHorizontal) !== null && _p$customStyles$thumb2 !== void 0 ? _p$customStyles$thumb2 : '';
});

exports.ThumbHorizontal = ThumbHorizontal;